export default "/images/google_ad_manager.png?a8178b732faf995a8dea4b1b1bdb9fbd";